(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/map-of-winners/assets/javascripts/prescript.js') >= 0) return;  svs.modules.push('/modules/map-of-winners/assets/javascripts/prescript.js');

(function(Backbone, _, svs) {
  'use strict';

  svs.tur = svs.tur || {};
  svs.map_of_winners = svs.map_of_winners || {};
  svs.map_of_winners.views = svs.map_of_winners.views || {};
  svs.map_of_winners.models = svs.map_of_winners.models || {};
  svs.map_of_winners.collections = svs.map_of_winners.collections || {};
  svs.map_of_winners.templates = svs.map_of_winners.templates || {};
  svs.map_of_winners.data = svs.map_of_winners.data || {};
})(Backbone, _, svs);


 })(window);